module.exports = __webpack_public_path__ + "img/188.fb57b923.jpg";